module.exports = __webpack_public_path__ + "39adeb316877d1b3a36d1a07aaffede4.svg";